import React from "react";
import {
	Edit,
	FormDataConsumer,
	NumberInput,
	SimpleForm,
	TextInput,
	maxLength,
	minValue,
} from "react-admin";

import { ActionsWithBackButton } from "../../../components/actionbars/ActionsWithBackButton";
import { GridForm, GridInput } from "../../../components/GridForm/";
import { OSFCUserSelectInput } from "../../../components/inputs/OSFCUserSelect";
import { PortSelectInput } from "../../../components/inputs/PortSelectInput";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";

const GroupPortSelectInput = ({ record = {}, ...props }) => (
	<PortSelectInput {...props} record={record} terminalId={record.terminal_id} />
);

const PreAssignmentInput = ({ record = {}, ...props }) => (
	<OSFCUserSelectInput
		{...props}
		record={record}
		filter={{ operational_terminal_id: record.terminal_id }}
	/>
);

export const OrderGroupEdit = (props) => (
	<Edit {...props} actions={<ActionsWithBackButton />} undoable={false}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
			<GridForm>
				<GridInput sm={2} component={NumberInput} source="rank" min={0} validate={minValue(0)} />
				<GridInput sm={2}>
					<FormDataConsumer>
						{({ formData }) => (
							<YesNoInput
								source="is_confirmed"
								disabled={!!formData.task_taken_by}
								margin="none"
								size="small"
								fullWidth
							/>
						)}
					</FormDataConsumer>
				</GridInput>
				<FormDataConsumer>
					{({ formData }) =>
						!(formData.task_taken_by && !formData.task_on_hold_assignee_id) && (
							<GridInput
								sm={4}
								component={PreAssignmentInput}
								source="task_on_hold_assignee_id"
								record={formData}
								resource={props.resource}
								basePath={props.basePath}
								margin="none"
								size="small"
							/>
						)
					}
				</FormDataConsumer>
				<GridInput sm={2} component={TextInput} source="truck" validate={maxLength(64)} />
				<GridInput sm={2} component={TextInput} source="trailer" validate={maxLength(64)} />
				<GridInput sm={2} component={TextInput} source="trip_number" validate={maxLength(16)} />
				<GridInput sm={2} component={GroupPortSelectInput} source="port" />
			</GridForm>
		</SimpleForm>
	</Edit>
);
